import Gettext, { type GettextInterface, type LocaleData } from "@indeed/indeed-gettext";

import type { Locale } from "./Locale";

export function emptyCatalog(): LocaleData {
  return { "": {} };
}

export function buildMockI18n(config: LocaleData = emptyCatalog()): GettextInterface {
  return Gettext(config);
}

/**
 *
 * @param locale
 * @returns An empty translations catalog. On web, translations are provided by the server render rather than inlined in the bundle
 */
export function loadCatalog(_locale: Locale): LocaleData {
  return emptyCatalog();
}
